/**
 * Valuation Calculator Utility Functions
 * Extracted from ValuationCalculator.jsx for better organization
 */

/**
 * Format number with commas for display
 * @param {number|string} value - The value to format
 * @returns {string} Formatted string with commas
 */
export const formatNumberWithCommas = (value) => {
  if (!value && value !== 0) return '';
  // Remove existing commas and non-numeric chars except decimal point and minus
  const numStr = value.toString().replace(/[^\d.-]/g, '');
  const parts = numStr.split('.');
  // Add commas to integer part
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

/**
 * Parse formatted number string to pure number
 * @param {string} value - The formatted value
 * @returns {string} Pure number string without commas
 */
export const parseNumberFromFormatted = (value) => {
  if (!value) return '';
  // Remove commas and return pure number string
  return value.toString().replace(/,/g, '');
};

/**
 * Format value as currency
 * @param {number} value - The value to format
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (value) => {
  if (!value) return '$0';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

/**
 * Get user ID from localStorage
 * @returns {string} User ID or 'anonymous'
 */
export const getUserId = () => {
  try {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      const user = JSON.parse(userStr);
      return user.id || 'anonymous';
    }
  } catch (e) {
    console.error('Error getting user ID:', e);
  }
  return 'anonymous';
};
